import type { CSSProperties } from "react";
import { cn } from "@/lib/cn";

type StorydocSparklesIconProps = {
  size?: number;
  className?: string;
  style?: CSSProperties;
};

export const StorydocSparklesIcon = ({ size = 16, className, style }: StorydocSparklesIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={cn(className)}
    style={style}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.15314 8.63111L5.32226 9.66487L5.74643 8.63111C6.3773 7.09508 7.73837 5.8939 9.34374 5.45807L10.4229 5.16575L9.41622 4.87342C7.91824 4.4376 6.85516 3.23641 6.60281 1.70039L6.43368 0.666626L6.00951 1.70039C5.37864 3.23641 4.01757 4.4376 2.4122 4.87342L1.33301 5.16575L2.33972 5.45807C3.83771 5.8939 4.90079 7.09508 5.15314 8.63111ZM13.6874 8.76663C12.8014 8.50885 12.1706 7.79931 12.0229 6.89045L11.8806 6.02411L11.5236 6.89045C11.1504 7.79931 10.3451 8.50885 9.39474 8.76663L8.48736 9.01378L9.33299 9.26092C10.2189 9.5187 10.8498 10.2282 10.9974 11.1371L11.1397 12.0034L11.4968 11.1371C11.8699 10.2282 12.6753 9.5187 13.6256 9.26092L14.533 9.01378L13.6874 8.76663ZM7.11301 10.6933L7.20697 11.278C7.33315 12.038 7.85932 12.6333 8.60026 12.8485L9.17207 13.0133L8.55999 13.1781C7.76535 13.3933 7.09154 13.9886 6.78013 14.7486L6.5412 15.3333L6.44724 14.7486C6.32106 13.9886 5.79489 13.3933 5.05395 13.1781L4.48213 13.0133L5.09421 12.8485C5.88884 12.6333 6.56267 12.038 6.87408 11.278L7.11301 10.6933Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
